import FilterList, {
	FilterValues,
	OptionsFilter,
} from 'projects/access-control/src/app/Domain/Entities/filter-list.interface';
import { Module } from 'projects/access-control/src/app/Domain/Entities/module.interface';
import { Resource } from 'projects/access-control/src/app/Domain/Entities/resource-interface';
import {
	deleteModule,
	deleteResourceModule,
	getResourcesModule,
} from 'projects/access-control/src/app/Infrastructure/Store/systems-module/systems-module.action';
import { FilterTablePipe } from 'projects/access-control/src/app/Infrastructure/pipes/filter-table.pipe';
import { ModalAddResourceComponent } from 'projects/access-control/src/app/UI/components/modal-add-resource/modal-add-resource.component';
import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import filtersResourceTable from './filtersResourceTable';
import { FiltersService } from 'projects/access-control/src/app/Infrastructure/Services/filters/filters.service';
import { DataPagination } from 'projects/access-control/src/app/Domain/Adapters';
import { IPkSk } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { OptionsTable } from 'projects/access-control/src/app/Domain/Entities/options-table.interface';

@Component({
	selector: 'app-resources',
	templateUrl: './resources.component.html',
	styleUrls: ['./resources.component.scss'],
})
export class ResourcesComponent implements OnInit {
	@Input() moduleSelect: Module = {} as Module;
	@Input() translate: any;
	@Input() filterList: FilterList[] = filtersResourceTable;
	@Input() columnsFilter: OptionsFilter[] = [
		{ name: 'name', label: 'Name' },
		{ name: 'action', label: 'Action' },
		{ name: 'path', label: 'Path' },
	];
	@Input() pagination!: DataPagination;
	@Input() isLoading: boolean = true;
	@Input() rowsFilter: Resource[] = [];
	filterResults: FilterValues[] = [] as FilterValues[];
	rows: Resource[] = [];
	resourceSelected: Resource = {} as Resource;
	optionsTable: OptionsTable[] = [
		{
			value: 'edit',
			icon: 'edit',
		},
		{
			value: 'delete',
			icon: 'delete',
		},
	] as OptionsTable[];
	elementsDelete: string = '';
	selectionType = SelectionType;
	selected: Resource[] = [];
	moduleDelete: Module = {} as Module;
	openAlert: boolean = false;
	valueModalDelete = '';
	nameModal = 'modalAlertDeleteElement';
	activeFilter = false;
	url: string = '';
	modeColum!: any;

	constructor(
		private store: Store,
		public dialog: MatDialog,
		private filter: FilterTablePipe,
		private filterService: FiltersService
	) {}


	ngOnInit(): void {
    this.modeColum = ColumnMode.force;
	}
  getFilterValues(filter: FilterValues[]) {
    this.filterResults = filter;
    this.rowsFilter = this.filter.transform(this.rows, filter) as Resource[];
  }
	openDialogResource(type = 'create', resource: Resource = {} as Resource): void {
		const dialogRef = this.dialog.open(ModalAddResourceComponent, {
			height: '620px',
			width: '600px',
			data: { module: this.moduleSelect, type, resource },
		});
		dialogRef.afterClosed().subscribe((res) => {});
	}

	buttonAction(option: string) {
		if (option === 'refresh') {
			this.store.dispatch(getResourcesModule({ url: this.moduleSelect.relationships.self }));
		} else {
			this.valueModalDelete = 'bulkDeleteResource';
			this.elementsDelete = '';
			if (this.selected.length > 0) {
				this.nameModal = 'modalAlertDeleteElement';
				this.elementsDelete = `${this.selected.length} ${
					this.selected.length > 1
						? this.translate.deleteBulkResource
						: this.translate.deleteResource
				}`;
			} else {
				this.nameModal = 'modalAlertDeleteNoSelected';
			}
			this.openAlert = true;
		}
	}
	filterSelected(options: OptionsFilter[]) {
		this.url = this.filterService.createUrl(options);
		if (this.url.length > 0) {
			this.activeFilter = true;
			this.store.dispatch(
				getResourcesModule({
					url: `${this.moduleSelect.relationships.self}/query${this.url}`,
				})
			);
		} else {
			this.activeFilter = false;
			this.store.dispatch(getResourcesModule({ url: this.moduleSelect.relationships.self }));
		}
	}
	closeModalAlert(event: any) {
		this.openAlert = false;
		if (event.resp && event.value === 'deleteModule') {
			this.deleteModule(this.moduleDelete);
		} else if (event.resp && event.value === 'deleteResource') {
			const ids: IPkSk[] = [{ pk: this.resourceSelected.pk, sk: this.resourceSelected.sk }];
			const module: IPkSk = { pk: this.moduleSelect.pk, sk: this.moduleSelect.sk };
			this.store.dispatch(deleteResourceModule({ ids, module }));
		} else if (event.resp && event.value === 'bulkDeleteResource') {
			const ids: IPkSk[] = this.selected.map((resource) => {
				return { pk: resource.pk, sk: resource.sk };
			});
			const module: IPkSk = { pk: this.moduleSelect.pk, sk: this.moduleSelect.sk };
			this.store.dispatch(deleteResourceModule({ ids, module }));
		}
		this.moduleDelete = {} as Module;
		this.selected = [];
		this.elementsDelete = '';
	}

	deleteModule(module: Module) {
		this.store.dispatch(deleteModule({ module }));
	}

	emitNavigation(page: any) {
		if (this.activeFilter) {
			this.store.dispatch(
				getResourcesModule({
					url: `${this.moduleSelect.relationships.self}/query${this.url}&_size=10&_page=${page}`,
				})
			);
		} else {
			const url = this.moduleSelect.relationships.self + `?_size=10&_page=${page}`;
			this.store.dispatch(getResourcesModule({ url }));
		}
	}

	actions(event: any) {
		if (event.action === 'edit') {
			this.openDialogResource(event.action, event.value);
		} else {
			this.nameModal = 'modalAlertDeleteElement';
			this.resourceSelected = event.value;
			this.elementsDelete = `${this.translate.deleteResource} '${event.value.name} '`;
			this.valueModalDelete = 'deleteResource';
			this.openAlert = true;
		}
	}

	onSelect({ selected }: any) {
		this.selected.splice(0, this.selected.length);
		selected.forEach((element: any) => {
			this.selected.push(element);
		});
	}
}
